var TxtType = function(el, toRotate, period) {
    this.toRotate = toRotate;
    this.el = el;
    this.loopNum = 0;
    this.period = parseInt(period, 10) || 2000;
    this.txt = 'veebilahendust?';
    this.tick();
    this.isDeleting = true;
};

TxtType.prototype.tick = function() {
    var i = this.loopNum % this.toRotate.length;
    var fullTxt = this.toRotate[i];

    if (this.isDeleting) {
        this.txt = fullTxt.substring(0, this.txt.length - 1);
    } else {
        this.txt = fullTxt.substring(0, this.txt.length + 1);
    }

    this.el.innerHTML = '<span class="wrap">'+this.txt+'</span>';

    var that = this;
    var delta = 200 - Math.random() * 100;

    if (this.isDeleting) { delta /= 2; }

    if (!this.isDeleting && this.txt === fullTxt) {
        delta = this.period;
        this.isDeleting = true;
    } else if (this.isDeleting && this.txt === '') {
        this.isDeleting = false;
        this.loopNum++;
        delta = 500;
    }

    setTimeout(function() {
        that.tick();
    }, delta);
};

window.onload = function() {
    var elements = document.getElementsByClassName('typewrite');
    for (var i=0; i<elements.length; i++) {
        var toRotate = elements[i].getAttribute('data-type');
        var period = elements[i].getAttribute('data-period');
        if (toRotate) {
            new TxtType(elements[i], JSON.parse(toRotate), period);
        }
    }
};

window.onscroll = function() {
    stikyMenu();
    scrollClass();
    featuredScrollClass();
};

function stikyMenu() {
    const header = document.querySelector(".navigation");
    const offsetTop = document.querySelector("#page").offsetTop;
    const mainWrapper = document.querySelector("#page");
    const pageYOffset = window.pageYOffset;
    const height = document.body.clientHeight;
    let isSticky = pageYOffset > offsetTop;
    let notSticky = pageYOffset <= offsetTop;
    let maxHeighth = ((height- (offsetTop + header.offsetHeight))) > (offsetTop + header.offsetHeight)
    if(maxHeighth) {
        if (notSticky) {
            if (header.classList.contains("sticky")) {
                header.classList.remove("sticky");
                mainWrapper.classList.remove("sticky");

            }
        } else if (isSticky) {
            if (!header.classList.contains("sticky")) {
                header.classList.add("sticky");
                mainWrapper.classList.add("sticky")

            }
        }
    }
}

const tabTiles = document.querySelectorAll(".tab-title")
const tabs = document.querySelectorAll('.tab')

if(tabTiles != null) {
    tabTiles.forEach((tabTile) => tabTile.addEventListener('click', tabSwitch))
    for (let i = 1; i < tabs.length; i++) {
        tabs[i].classList.add('hide')
    }
}

function tabSwitch(event){
    event.preventDefault()
    tabTiles.forEach((tabTile) => tabTile.classList.remove('active'))
    const id = this.dataset.tab
    this.classList.add('active')



    tabs.forEach((tab) => {
        if(tab.id === id){
            tab.classList.remove('hide')
        } else {
            tab.classList.add('hide')
        }
    })
}

const mobile_menu = document.querySelector('.mobile-menu');
const mobile_toggle = document.querySelectorAll('.menu-toggle');


mobile_toggle.forEach((item)=>item.addEventListener('click', handleMenuToggle));
document.addEventListener('click', handleClickArea);

function handleMenuToggle() {
    mobile_menu.classList.toggle('hidden')
    body.classList.toggle('overflow-hidden')
    body.classList.toggle('mobile-active')
    mobile_toggle.forEach((item)=>item.classList.toggle('is-active'))
}
function handleClickArea(e) {
    console.log(e.target)
    if(e.target == mobile_menu){
        handleMenuToggle()
    }
}

const menu_items = document.querySelectorAll('.mobile-menu .menu-item')
menu_items.forEach((item)=>{
    item.children[0].addEventListener('click', handleMenuToggle);
})

const sections = document.querySelectorAll('.color-background');
const html = document.querySelector('html');
const body = document.querySelector('body');

function scrollClass() {
    for (const section of sections) {
        if (section.getBoundingClientRect().top <= window.innerHeight * 0.75 && section.getBoundingClientRect().top > 0) {
            if(section.id !=null){
                html.setAttribute("class", section.id);
            }
        }
    }
};

const featured = document.querySelectorAll('.wp-block-lazyblock-featured');
if(featured != null){
    for (let i = 0; i < featured.length; i++) {
        featured[i].classList.add(`feature-${i}`)
    }
}
function featuredScrollClass() {
    for (const feature of featured) {
        if (feature.getBoundingClientRect().top <= window.innerHeight  && feature.getBoundingClientRect().top > 0) {
            if(feature.id !=null){
                feature.classList.add("activate-animation");
            }
        }
    }
};
